import React, { useState, useEffect, useRef } from 'react';
import { LabelField } from './Static.style';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import ConfBar from '../ConfBar/ConfBar';
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { InputNumber } from 'primereact/inputnumber';
import Video from '../Video/Video';
import InfoIcon from '../InfoIcon/InfoIcon';
import useInfo from '../hooks/useInfo';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import { tableDate, timeToDate } from '../../services/tableDate.service';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { FileUpload } from "primereact/fileupload";
import { saveAs } from 'file-saver';
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { excelExport } from '../../services/excelExport.service';
import { excelReport } from '../../services/excelReport.service';
// import DateInput from 'opuscapita/react-dates'
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Static
Description : Pagina de Static para el CRUD de los cargos del aplicativo remunerlite.
Date Autor Modification
================================================================================
13/10/2021 Cristian Andres Pizo Mina - Pagina de Static.
23/11/2021 Cristian Andres Pizo Mina - Pagina de Static. se agregaron select con buscador y campo para fecha
================================================================================ */
export default function Static() {

  const toast = useRef(null);
  const setOptions_edit = []
  const setOptions_edit2 = []
  const setOptions_edit3 = []
  const setOptions_edit4 = []
  const [number_id, setNumber_id] = useState("");
  const [concept, setConcept] = useState("");
  const [afc, setAfc] = useState("");
  const [value, setValue] = useState(0);
  const [balance_value, setBalance_value] = useState("");
  const [period, setPeriod] = useState("")
  const [date_ini, setDate_ini] = useState("");
  const [date_end, setDate_end] = useState("");
  const [status, setStatus] = useState("");
  const [hasAFC, setHasAFC] = useState("")
  const [contracts, setContracts] = useState([]);
  const [updateNumber_id, setUpdateNumber_id] = useState("");
  const [updateConcept, setUpdateConcept] = useState("");
  const [updateValue, setUpdateValue] = useState(0);
  const [updateBalance_value, setUpdateBalance_value] = useState("");
  const [updateAfc, setUpdateAfc] = useState("");
  const [updatePeriod, setUpdatePeriod] = useState("")
  const [updateDate_ini, setUpdateDate_ini] = useState(new Date());
  const [updateDate_end, setUpdateDate_end] = useState(new Date());
  const [updateStatus, setUpdateStatus] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [listaCodEmpleado, setListaCodEmpleado] = useState([]);
  const [listaConcept, setListaConcept] = useState([]);
  const [listaAfc, setListaAfc] = useState([]);
  const [listaStatus, setListaStatus] = useState([]);
  const [static_id, setStaticId] = useState([]);
  const elementWidth = { width: "29rem" }
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpen_, setIsOpen_] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
  const [products, setProducts] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const headers = {
    authorization: localStorage.getItem('token')
  }
  const [smShowC, setSmShowC] = useState(false);
  const [isOpenC, setIsOpenC] = React.useState(false);

  const [nie, setNie] = useState("");

  const [listaNieDev, setListaNieDev] = useState([]);

  const [nombreConcepto, setNombreConcepto] = useState("");
  const [naturaleza, setNaturaleza] = useState("");
  const [tipoConcepto, setTipoConcepto] = useState("");
  const [tipoRetencion, setTipoRetencion] = useState("");
  const [agregado, setAgregado] = useState(false);
  const [listasCargadas, setListasCargadas] = useState(false)
  const [listasCargadasConcepto, setListasCargadasConcepto] = useState(false)

  const [listaNieDed, setListaNieDed] = useState([]);

  const [listaNaturaleza, setListaNaturaleza] = useState([]);
  const [listaTipoConcepto, setListaTipoConcepto] = useState([]);
  const [listaTipoRetencion, setListaTipoRetencion] = useState([]);

  const [listaReportadas, setListaReportadas] = useState([]);
  const [listaCalendario, setListaCalendario] = useState([]);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingAddConcept, setLoadingAddConcept] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false)
  const [exportContent, setExportContent] = useState([])
  const [listasPeriodos, setListasPeriodos] = useState([])
  const [listaPeriodoEspecifico, setListaPeriodoEspecifico] = useState([])
  const [contratoPeriodos, setContratoPeriodos] = useState("")
  const [listaCYR, setListaCYR] = useState([])
  const [cyr, setCyr] = useState("")
  const [loadPage, setLoadPage] = useState(false)
  const [isOpenCargue, setIsOpenCargue] = React.useState(false);

  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const [consultado, setConsultado] = useState(false);
  const fileUploadRef = useRef(null);

  /*Mensajes informativos*/
  const { info } = useInfo("NoveltiesStatic");

  useEffect(() => {
    setTabla();
    setListas()
  }, []);

  async function setListas() {
    await apis.getStaticsLists(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
      setContracts(res.data["CONTRACTS"])
      let codsEmpleados = res.data["CONTRACTS"]
      let contenidoCodEmpleado = []
      let concept = res.data["CONCEPTS"]
      let contenidoConcept = []
      let status = res.data["ESTADOS MODULOS"]
      let contenidoStatus = []
      let contenidoPeriodos = []

      codsEmpleados.forEach(element => {
        contenidoCodEmpleado.push({ "value": '' + element.CODE + '', "label": '' + element.NAME + '' });
        contenidoPeriodos.push(element)
      })
      console.log(contenidoPeriodos)
      setListasPeriodos(contenidoPeriodos)
      setListaCodEmpleado(contenidoCodEmpleado);

      concept.forEach(element => {
        contenidoConcept.push({ "value": '' + element.CODE + '-' + element.AFCFVOL + '', "label": '' + element.NAME + '' });
      })
      setListaConcept(contenidoConcept);

      status.forEach(element => {
        contenidoStatus.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' });
      })
      setListaStatus(contenidoStatus);
      setStatus(contenidoStatus[0])
      setListasCargadas(true)
    })
  }

  async function setListasConceptos() {
    try {
      await apis.getValueListReportedConcepts(headers).then(res => {
        let listas = res.data["TYPE_CONCEPTS"]
        let contenidoNaturaleza = [
          { DETAIL_ID: listas[0]["DETAIL_ID"], DESCRIPTION: listas[0]["DESCRIPTION"] },
          { DETAIL_ID: listas[1]["DETAIL_ID"], DESCRIPTION: listas[1]["DESCRIPTION"] }
        ]
        let contenidoTipoConcepto = listas[0]["OPTIONS"][0]["LITE_TIPO_CONCEPTO"]
        let contenidoTipoRetencion = listas[0]["OPTIONS"][1]["LITE_BASE_RETE"]
        let contenidoNieDev = listas[0]["OPTIONS"][2]["NIE_DEV"]
        let contenidoNieDed = listas[1]["OPTIONS"][0]["NIE_DED"]
        let contenidoCYR = res.data["CYR"]
        setListaNaturaleza(contenidoNaturaleza)
        setListaTipoConcepto(contenidoTipoConcepto)
        setListaTipoRetencion(contenidoTipoRetencion)
        setListaNieDev(contenidoNieDev)
        setListaNieDed(contenidoNieDed)
        setListaCYR(contenidoCYR)
        setListasCargadasConcepto(true)
      })
    }
    catch (err) {
    }
  }

  function setListaPeriodo(empleado) {
    console.log("ssss: ", empleado)
    console.log(listasPeriodos)
    if (empleado) {
      let periodo = listasPeriodos.find(el => el.CODE == empleado).PERIOD
      setListaPeriodoEspecifico(periodo)
    }
    else {
      setListaPeriodoEspecifico([])
    }
    // listasPeriodos.forEach(element => {
    //   if (element.CODE === empleado) {
    //     setListaPeriodoEspecifico(element.PERIOD)
    //   }
    // })
  }

  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Claro'
  });

  const showModal = () => {
    // if (!listasCargadas) {
    //   setListas()
    // }
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
    limpiar();
  };

  const showModal_ = (contract) => {
    // if (!listasCargadas) {
    //   // setListas()
    // }
    setContratoPeriodos(contract)
    setIsOpen_(true);
  };

  const hideModal_ = () => {
    setIsOpen_(false)
  };

  const showModalEliminar = (STATIC_ID) => {

    setDeleteId(STATIC_ID);
    setIsOpenEliminar(true);

  };

  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };


  const showModalC = () => {
    if (!listasCargadasConcepto) {
      setListasConceptos()
    }
    setIsOpenC(true);
  };

  const hideModalC = () => {
    setIsOpenC(false);
    limpiarConcept();
  };

  const showModalCargue = () => {
    setIsOpenCargue(true);
  };

  const hideModalCargue = () => {
    setIsOpenCargue(false);
  };

  async function setTabla() {
    await apis.getStatics(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
      if (res.data["NOVELTIES"].length > 0) {
        let data = res.data["NOVELTIES"]
        let contenidoTabla = []
        let contenidoExport = []
        data.forEach(element => {
          let status = element["STATUS"].split("|")
          let datos = element["NAME"].split("|")
          let concept = element["CONCEPT_ID"].split("|")
          console.log(element["CONCEPT_ID"])
          let period = element["PERIOD"].split("|")
          let entidadSS;
          let idEntidadSS;
          let fechaInicio = tableDate(element.DATE_INI)
          let fechaFin = tableDate(element.DATE_END)
          if (element["ENTIDADSS"]) {
            idEntidadSS = element["ENTIDADSS"].split("|")[0]
            entidadSS = element["ENTIDADSS"].split("-")[1]
          } else {
            idEntidadSS = ""
            entidadSS = ""
          }
          contenidoTabla.push({
            STATIC_ID: element.STATIC_ID, ENTIDADSS_ID: idEntidadSS, ENTIDADSS: entidadSS, CONTRACT_ID: element.CONTRACT_ID,
            DATE_INI: fechaInicio, DATE_END: fechaFin, NUMBER_ID: datos[0], NAME: datos[1], ID_STATUS: status[0],
            STATUS: status[1], BALANCE_VALUE: element.BALANCE_VALUE, BALANCE_END: element.BALANCE_END, VALUE: element.VALUE, CONCEPT_ID: concept[0], CONCEPT: concept[1],
            PERIOD_ID: period[0], PERIOD: period[1], AFCFVOL: element.AFCFVOL
          })
          contenidoExport.push({
            Contrato: element.CONTRACT_ID, "Identificación": datos[0], Nombre: datos[1], Concepto: concept[1], "Entidad AFC o FVOL": entidadSS,
            Valor: element.VALUE, "Saldo inicial": element.BALANCE_VALUE, "Saldo final": element.BALANCE_END, "Período": period[1], "Fecha inicio": element.DATE_INI, "Fecha fin": element.DATE_END,
            Estado: status[1]
          })
        })
        console.log(contenidoTabla)
        setProducts(contenidoTabla)
        setExportContent(contenidoExport)
        setLoadPage(true)
      } else {
        setProducts([])
        setExportContent([])
        setLoadPage(true)
      }
    }).catch(err => {
      setLoadPage(true)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })
  }


  function inizilaizarData(rowData) {
    setOptions_edit.push({ "value": '' + rowData.ID_STATUS + '', "label": '' + rowData.STATUS + '' });
    setOptions_edit2.push({ "value": '' + rowData.CONTRACT_ID + '', "label": '' + rowData.CONTRACT_ID + '' });
    setOptions_edit3.push({ "value": '' + rowData.CONCEPT_ID + '', "label": '' + rowData.CONCEPT + '' });
    setOptions_edit4.push({ "value": '' + rowData.ENTIDADSS_ID + '', "label": '' + rowData.ENTIDADSS + '' });
    setUpdatePeriod({ ID: rowData.PERIOD_ID, NAME: rowData.PERIOD })
    let fechaInicio = timeToDate(rowData.DATE_INI)
    let fechaFin = timeToDate(rowData.DATE_END)
    setUpdateDate_ini(invDateFormat(fechaInicio))
    setUpdateDate_end(invDateFormat(fechaFin))
    setUpdateNumber_id(setOptions_edit2[0]);
    setUpdateConcept(setOptions_edit3[0]);
    setUpdateAfc(setOptions_edit4[0]);
    setUpdateValue(rowData.VALUE);
    setUpdateBalance_value(rowData.BALANCE_VALUE);
    setUpdateStatus(setOptions_edit[0]);
    setStaticId(rowData.STATIC_ID)
    setHasAFC(rowData.AFCFVOL)
    updateListarAFC({ value: rowData.CONCEPT_ID + '-' + rowData.AFCFVOL, label: rowData.CONCEPT }, rowData.CONTRACT_ID)
    showModal_(+rowData.CONTRACT_ID);
  }

  function validar() {
    if (number_id.value == undefined) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Selecionar empleado', life: 4000 });
      return false
    } if (concept.value == undefined) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar concepto', life: 4000 });
      return false
    } if (value == "") {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar valor', life: 4000 });
      return false
    } if (date_ini == undefined) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar fecha inicio', life: 4000 });
      return false
    }
    return true
  }



  async function completarRegistro() {

    if (validar()) {
      setLoadingCreate(true)
      const _cliente = localStorage.getItem('client')
      const _entity = localStorage.getItem('entity')
      const _number_id = number_id.value;
      const _concept = concept.value.split("-")[0];
      const _value = value;
      let _balance_value = balance_value;
      if (_balance_value === 0) {
        _balance_value = ""
      }
      const _date_ini = dateFormat(date_ini);
      const _date_end = dateFormat(date_end);
      const _status = status.value;
      const _afc = afc.value;
      const _period = period.ID
      const statica = {
        CLIENT: _cliente,
        ENTITY: _entity,
        CONTRACT_ID: _number_id,
        CONCEPT_ID: _concept,
        VALUE: _value,
        BALANCE_VALUE: _balance_value,
        DATE_INI: _date_ini,
        DATE_END: _date_end,
        STATUS: _status,
        ENTIDADSS: _afc,
        PERIOD: _period
      }
      console.log(statica)
      await apis.postStatics(statica, headers).then(staticas => {
        setIsOpen(false)
        setLoadingCreate(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Registro agregado exitosamente', life: 4000 });
        hideModal();
        setTabla();
        setListas()
        limpiar();
      }).catch(err => {
        setLoadingCreate(false)
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
  }

  async function actualizar() {
    setLoadingUpdate(true)
    const _client = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _id_calendar = null;
    const _contract_id = updateNumber_id.value;
    const _date_ini = dateFormat(updateDate_ini);
    const _date_end = dateFormat(updateDate_end);
    const _concept = updateConcept.value.split("-")[0];
    const _value = updateValue;
    let _balance_value = updateBalance_value;
    if (_balance_value === 0) {
      _balance_value = ""
    }
    const _status = updateStatus.value;
    const _static_id = static_id;
    const _period = updatePeriod.ID
    let _afc;

    if (updateAfc.value) {
      _afc = updateAfc.value;
    } else {
      _afc = null;
    }

    const statica = {
      CLIENT: _client,
      ENTITY: _entity,
      ID_CALENDAR: _id_calendar,
      CONTRACT_ID: _contract_id,
      CONCEPT_ID: _concept,
      VALUE: _value,
      BALANCE_VALUE: _balance_value,
      DATE_INI: _date_ini,
      DATE_END: _date_end,
      STATUS: _status,
      ENTIDADSS: _afc,
      STATIC_ID: _static_id,
      PERIOD: _period
    }
    console.log(statica)
    await apis.putStatics(statica, headers).then(res => {
      setIsOpen_(false);
      setLoadingUpdate(false)
      toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Registro actualizado exitosamente', life: 4000 });
    }).catch(err => {
      setLoadingUpdate(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })

    setTabla();
    setListas()
  }

  async function eliminar() {
    setLoadingDelete(true)
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _idStactic = deleteId;
    await apis.deleteStatics(_entity, _cliente, _idStactic, headers).then(res => {
      setIsOpenEliminar(false)
      setLoadingDelete(false)
      toast.current.show({ severity: 'info', summary: 'Éxito', detail: 'Novedad eliminada', life: 4000 });
    }).catch(err => {
      setLoadingDelete(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })

    setTabla();
    setListas()
  }

  async function limpiar() {
    setNumber_id("");
    setConcept("");
    setValue("");
    setBalance_value("");
    setDate_ini(null);
    setDate_end(null);
    setAfc("");
    setPeriod("")
  }

  async function limpiarConcept() {
    setNombreConcepto("")
    setNaturaleza("")
    setTipoConcepto("")
    setTipoRetencion("")
    setNie("")
    setCyr("")
  }

  const listarAFC = async (event) => {
    setConcept(event.value ? event : "")
    if (number_id) {
      console.log(event.value)
      if (event.value && event.value.split("-")[1] === '1') {
        let afcs = contracts.find(el => el.CODE == number_id.value).AFCFVOL
        let _afcs = []
        afcs.forEach((a) => {
          if (a.CODE !== '-1') {
            _afcs.push(a)
          }
        })
        let contenidoAfc = []
        _afcs.forEach(element => {
          contenidoAfc.push({ "value": '' + element.CODE + '', "label": '' + element.NAME.split('-')[1] + '' });
        })
        setListaAfc(contenidoAfc);
        // setAfc("")
      } else {
        setListaAfc([])
        setAfc("")
      }
    }
  }

  const updateListarAFC = (event, id) => {
    setUpdateConcept(event.value ? event : "")
    if (event.value && contracts.length > 0 && event.value.split("-")[1] === '1') {
      console.log(contracts)
      console.log(updateNumber_id)
      let afcs = contracts.find(el => el.CODE == id && el.CODE !== '-1').AFCFVOL
      let _afcs = []
      afcs.forEach((a) => {
        if (a.CODE !== '-1') {
          _afcs.push(a)
        }
      })
      let contenidoAfc = []
      _afcs.forEach(element => {
        contenidoAfc.push({ "value": '' + element.CODE + '', "label": '' + element.NAME.split('-')[1] + '' });
      })
      setListaAfc(contenidoAfc);
      // setUpdateAfc("")
    } else {
      setListaAfc([])
      setUpdateAfc("")
    }
  }

  const listarAFCUsuarios = async (event) => {
    console.log(event)
    setNumber_id(event)
    setListaPeriodo(event.value)
    setListaAfc([])
    setAfc("")
    setConcept("")
  }

  async function updateListConcepts() {
    await apis.getStaticsLists(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
      let concept = res.data["CONCEPTS"]
      let contenidoConcept = []

      concept.forEach(element => {
        contenidoConcept.push({ "value": '' + element.CODE + '-' + element.AFCFVOL + '', "label": '' + element.NAME + '' });
      })
      setListaConcept(contenidoConcept);

    })
  }

  async function postReportedConcept() {
    setLoadingAddConcept(true)
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _nombre = nombreConcepto
    const _naturaleza = naturaleza.DETAIL_ID
    const _nie = nie.detail_id
    const _cyr = cyr.IDGROUP
    const _modulo = "STA"
    let _tipoConcepto = ""
    let _tipoRetencion = ""

    if (_naturaleza === "367") {
      _tipoConcepto = tipoConcepto.detail_id
      _tipoRetencion = tipoRetencion.detail_id
    }

    const concept = {
      CLIENT: _cliente,
      ENTITY: _entity,
      NAME: _nombre,
      TYPE_CONCEPTS: _naturaleza,
      MODULE: _modulo,
      TYPE_CONCEPT: _tipoConcepto,
      TYPE_RETE: _tipoRetencion,
      NE_DIAN: _nie,
      CYR: _cyr
    }

    try {
      await apis.postReportedConcept(concept, headers).then(res => {
        setLoadingAddConcept(false)
        setAgregado(true)
        limpiar();
        hideModalC()
        updateListConcepts();
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Concepto agregado exitosamente' });
      })
    }
    catch (err) {
      setLoadingAddConcept(false)
      toast.current.show({ severity: 'error', summary: 'Error', detail: err.response.data.message, sticky: true });
    }
  }

  const exportExcel = () => {
    try{
      excelExport(exportContent, 'NovedadesFijas')
      toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Exportado con éxito" });
    }
    catch (err){
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al exportar", sticky: true });
    }
    finally{
      setLoadingExport(false)
    }
  }
  
  async function downloadSampleFile() {
    let payload = {
      NAME: "UploadStatics",
      CLIENT: localStorage.getItem('client'),
      ENTITY: localStorage.getItem('entity'),
      OPTION: 2
    }
    let sampleFile = []
    try {
      await apis.uploadStatics(payload, headers).then(res => {
        sampleFile = res.data
        let nombre = sampleFile["SHEETS"][0]["NAME"]
        excelReport(sampleFile, nombre)
        setLoading5(false)
      });
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
      setLoading5(false)
    }
  }

  async function loadError(lines) {
    /*Función encargada de gnerar el archivo txt de errores del cargue*/
    const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
    saveAs(blob, "ErroresCargue.txt");
  }

  async function importData(_importedData) {
    /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
    try {
      await apis.uploadStatics(_importedData, headers).then(res => {
        setConsultado(false)
        toast.current.clear()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
        setTabla()
      })
    }
    catch (err) {
      loadError(err.response.data.message)
      setConsultado(false)
      toast.current.clear()
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
    }
  }

  async function importCargue(e) {
    /*Función encargada de formatear los datos del archivo Excel para subirlos*/
    setConsultado(true);
    showConfirm();
    const file = e.files[0];

    import('xlsx').then(xlsx => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

        // Prepare DataTable
        data.shift();

        let _importedData = {
          NAME: "UploadStatics",
          CLIENT: localStorage.getItem('client'),
          ENTITY: localStorage.getItem('entity'),
          OPTION: 1,
          DETAIL: []
        }

        let lines = 1
        data.forEach(row => {
          let _line = ""
          row.forEach(element => {
            _line += element + "|"
          })
          _line = _line.slice(0, -1)
          _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
          lines++
        })

        importData(_importedData)
      };
      reader.readAsArrayBuffer(file);
    });
  }

  const showConfirm = () => {
    /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
    toast.current.show({
      severity: 'info', sticky: true, content: (
        <div className="flex flex-column" style={{ flex: '1' }}>
          <div className="text-center">
            <i >
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />
            </i>
            <p>Cargando información...</p>
          </div>
        </div>
      )
    });
  }

  const footer = (
    <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
      <Button style={{ marginLeft: "-6rem" }} label='Cancelar' onClick={() => { setLoading5(false); setLoading6(false); hideModalCargue() }} />
      <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading5} onClick={() => { setLoading5(true); downloadSampleFile() }} />
      <FileUpload ref={fileUploadRef} disabled={consultado} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importCargue}>
      </FileUpload>
    </div>
  );

  const header = (
    <div>
      <h3>Cargar novedades fijas</h3>
    </div>
  )

  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton Agregar Persona izquierda de la tabla
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={showModal} />
        <Button label="Agregar concepto" icon="pi pi-calendar-plus" className="p-button-success mr-2 p-button-sm" onClick={() => showModalC()} />
        <Button label="Cargue fijas" icon="pi pi-upload" className="p-button-success mr-2 p-button-sm" onClick={() => showModalCargue()} />
        {/* <Button label="Eliminar" icon="pi pi-trash" className="p-button-danger p-button-sm" onClick={() => {showModalEliminar(selectedProducts)}}/> */}
      </React.Fragment>
    )
  }

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Exportar" icon="pi pi-file-excel" loading={loadingExport} className="p-button-success mr-2 p-button-sm" onClick={() => { setLoadingExport(true); exportExcel() }} />
      </React.Fragment>
    )
  }


  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex">
        <Button icon="pi pi-pencil" className="p-button-warning  p-button-sm text-xs mr-2" onClick={() => { inizilaizarData(rowData); }} />
        <Button icon="pi pi-trash" className="p-button-danger  p-button-sm text-xs" onClick={() => { showModalEliminar(rowData.STATIC_ID) }} />
      </div>
    )
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
        </IconField>
      </div>
    )
  }




  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CONCEPT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'ENTIDADSS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'VALUE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'BALANCE_VALUE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];



  const addFooter = (
    <div>
      <Button onClick={hideModal}>Cancelar</Button>
      <Button loading={loadingCreate} onClick={completarRegistro} label='Guardar'></Button>
    </div>
  );

  const addHeader = (
    <div>
      <h3>Agregar novedades fijas</h3>
    </div>
  );

  const updateFooter = (
    <div>
      <Button onClick={hideModal_}>Cancelar</Button>
      <Button loading={loadingUpdate} onClick={actualizar} label='Guardar'></Button>
    </div>
  );

  const updateHeader = (
    <div>
      <h3>Actualizar novedades fijas</h3>
    </div>
  );

  const deleteFooter = (
    <div>
      <Button onClick={hideModalEliminar}>Cancelar</Button>
      <Button loading={loadingDelete} onClick={eliminar} label='Si'></Button>
    </div>
  );

  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar la novedad fija?</h3>
    </div>
  );


  const formatCurrency = (value) => {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  const valueBodyTemplate = (rowData) => {
    if (rowData.VALUE) {
      return formatCurrency(parseInt(rowData.VALUE));
    } else {
      return "";
    }
  }

  const balanceValueBodyTemplate = (rowData) => {
    if (rowData.BALANCE_VALUE) {
      return formatCurrency(parseInt(rowData.BALANCE_VALUE));
    } else {
      return "";
    }

  }

  const balanceEndBodyTemplate = (rowData) => {
    if (rowData.BALANCE_END) {
      return formatCurrency(parseInt(rowData.BALANCE_END));
    } else {
      return "";
    }

  }

  const iniDateTemplate = (rowData) => {
    const date = timeToDate(rowData.DATE_INI);
    return date
  }

  const endDateTemplate = (rowData) => {
    const date = timeToDate(rowData.DATE_END);
    return date
  }

  const conceptFooter = (
    <div>
      <Button onClick={hideModalC}>Cancelar</Button>
      <Button onClick={postReportedConcept} loading={loadingAddConcept} label='Agregar'></Button>
    </div>
  );

  const conceptHeader = (
    <div>
      <h3>Agregar concepto</h3>
    </div>
  )


  return (
    <div>
      <Toast ref={toast} />
      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
        <Tooltip target=".info" className='indigo-tooltip ml-1' />
        <Dialog header={addHeader} footer={addFooter} visible={isOpen} position="top" style={{ width: "36rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <Tooltip target=".info" className='indigo-tooltip ml-1' />
          <LabelField htmlFor="label">Código empleado</LabelField>
          <InfoIcon msg={info[0]}
            element={
              <Dropdown showClear filter filterBy="label" style={elementWidth} value={number_id.value} options={listaCodEmpleado} placeholder={"Seleccione un usuario"} onChange={listarAFCUsuarios} />
            }
          />
          <LabelField htmlFor="label">Concepto</LabelField>
          <InfoIcon msg={info[1]}
            element={
              <Dropdown showClear filter filterBy="label" style={elementWidth} value={concept.value}
                disabled={!number_id} options={listaConcept} placeholder={"Seleccione un Concepto"} onChange={listarAFC} />
            }
          />
          <LabelField htmlFor="label">Entidad AFC ó FVOL</LabelField>
          <InfoIcon msg={info[2]}
            element={
              <Dropdown showClear filter filterBy="label" style={elementWidth} value={afc.value}
                disabled={!concept} options={listaAfc} placeholder={"Entidad AFC ó FVOL"} onChange={setAfc} emptyMessage={"El empleado no tiene entidades asignadas"} />
            }
          />
          <LabelField htmlFor="label">Valor</LabelField>
          <InfoIcon msg={info[3]}
            element={
              <InputNumber value={value} onChange={(e) => setValue(e.value)} style={{ width: "29rem" }}
                disabled={!concept} mode="currency" currency="COP" locale="es-CO" placeholder="Valor" />
            }
          />
          <LabelField htmlFor="label">Saldo inicial</LabelField>
          <InfoIcon msg={info[4]}
            element={
              <InputNumber value={balance_value} onChange={(e) => setBalance_value(e.value)} style={{ width: "29rem" }} mode="currency"
                currency="COP" locale="es-CO" placeholder="Saldo inicial" disabled={!concept} />
            }
          />
          <LabelField htmlFor="label">Fecha inicio</LabelField>
          <InfoIcon msg={info[5]}
            element={
              <Calendar style={elementWidth} id="navigators" value={date_ini} disabled={!concept}
                onChange={(e) => { setDate_ini(e.value) }} locale="es" dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon />
            }
          />
          <LabelField htmlFor="label">Fecha fin</LabelField>
          <InfoIcon msg={info[6]}
            element={
              <Calendar style={elementWidth} id="navigators" value={date_end} disabled={!concept}
                onChange={(e) => { setDate_end(e.value) }} locale="es" dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon />
            }
          />
          <LabelField htmlFor="label">Estado</LabelField>
          <InfoIcon msg={info[7]}
            element={
              <Dropdown showClear filter filterBy="label" style={elementWidth} value={status.value}
                disabled={!concept} options={listaStatus} onChange={setStatus} />
            }
          />
          <LabelField htmlFor="label">Período</LabelField>
          <InfoIcon msg={info[7]}
            element={
              <Dropdown showClear filter filterBy="label" style={elementWidth} value={period} options={listaPeriodoEspecifico}
                optionLabel="NAME" onChange={(e) => setPeriod(e.value)} disabled={!concept}
                emptyMessage={"El empleado no tiene períodos disponibles"} />
            }
          />
        </Dialog>

        <Dialog header={updateHeader} footer={updateFooter} visible={isOpen_} position="top" style={{ width: "36rem" }} draggable={false} resizable={false} modal onHide={hideModal_}>
          <LabelField htmlFor="label">Concepto</LabelField>
          <Dropdown showClear filter filterBy="label" style={elementWidth} value={updateConcept.value} options={listaConcept} onChange={(e) => updateListarAFC(e, updateNumber_id.value)} placeholder={updateConcept.label} />
          <LabelField htmlFor="label">Entidad AFC ó FVOL</LabelField>
          <Dropdown showClear filter filterBy="label" style={elementWidth} value={updateAfc.value} options={listaAfc} onChange={setUpdateAfc} placeholder={updateAfc.label} emptyMessage={"El empleado no tiene entidades asignadas"} />
          <LabelField htmlFor="label">Valor</LabelField>
          <InputNumber value={updateValue} onChange={(e) => setUpdateValue(e.value)} style={{ width: "29rem" }} mode="currency" currency="COP" locale="es-CO" placeholder="Valor" />
          <LabelField htmlFor="label">Saldo inicial</LabelField>
          <InputNumber value={updateBalance_value} onChange={(e) => setUpdateBalance_value(e.value)} style={{ width: "29rem" }} mode="currency" currency="COP" locale="es-CO" placeholder="Saldo inicial" />
          <LabelField htmlFor="label">Fecha inicio</LabelField>
          <Calendar style={elementWidth} id="navigators" value={updateDate_ini} onChange={(e) => { setUpdateDate_ini(e.value) }} locale="es" dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon />
          <LabelField htmlFor="label">Fecha fin</LabelField>
          <Calendar style={elementWidth} id="navigators" value={updateDate_end} onChange={(e) => { setUpdateDate_end(e.value) }} locale="es" dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon />
          <LabelField htmlFor="label">Estado</LabelField>
          <Dropdown showClear filter filterBy="label" style={elementWidth} value={updateStatus.value} options={listaStatus} onChange={setUpdateStatus} />
          <LabelField htmlFor="label">Período</LabelField>
          <Dropdown showClear filter filterBy="label" style={elementWidth} value={updatePeriod}
            options={contratoPeriodos !== "" && listasPeriodos.find(el => el.CODE == contratoPeriodos) ? listasPeriodos.find(el => el.CODE == contratoPeriodos).PERIOD : []}
            optionLabel="NAME" emptyMessage={"El empleado no tiene períodos disponibles"}
            onChange={(e) => setUpdatePeriod(e.value)} placeholder={updatePeriod ? updatePeriod.NAME : ""} />
        </Dialog>

        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>

        <Dialog header={conceptHeader} footer={conceptFooter} visible={isOpenC}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalC}>
          <LabelField htmlFor="label">Nombre</LabelField>
          <InputText
            style={{ width: "22rem" }}
            id="label2"
            autoFocus
            type="text"
            value={nombreConcepto}
            placeholder="Nombre"
            onChange={(e) => setNombreConcepto(e.target.value)}
          />
          <LabelField htmlFor="label">Naturaleza</LabelField>
          <Dropdown
            style={{ width: "22rem" }}
            value={naturaleza}
            filter showClear filterBy="DESCRIPTION"
            optionLabel="DESCRIPTION"
            options={listaNaturaleza} placeholder={"Seleccione un calendario"}
            onChange={(e) => {
              setNaturaleza(e.value)
            }}
          />
          {naturaleza !== undefined ? (naturaleza.DETAIL_ID === "367" ?
            <>
              <LabelField htmlFor="label">Tipo concepto *</LabelField>
              <Dropdown style={{ width: "22rem" }} value={tipoConcepto}
                filter showClear filterBy="description"
                optionLabel="description"
                options={listaTipoConcepto} placeholder={"Seleccione un empleado"}
                onChange={(e) => {
                  setTipoConcepto(e.value)
                }}
              />
            </> : null)
            : null}
          {naturaleza !== undefined ? (naturaleza.DETAIL_ID === "367" ?
            <>
              <LabelField htmlFor="label">¿Hace base de retención?</LabelField>
              <Dropdown
                style={{ width: "22rem" }}
                value={tipoRetencion}
                filter showClear filterBy="description"
                optionLabel="description"
                options={listaTipoRetencion} placeholder={"Seleccione el calendario"}
                onChange={(e) => {
                  setTipoRetencion(e.value)
                }}
              />
            </> : null)
            : null}
          {naturaleza !== undefined ? (naturaleza.DETAIL_ID === "367" ?
            <>
              <LabelField htmlFor="label">NIE DIAN *</LabelField>
              <Dropdown style={{ width: "22rem" }} value={nie}
                filter showClear filterBy="description"
                optionLabel="description"
                options={listaNieDev} placeholder={"Seleccione un NIE"}
                onChange={(e) => {
                  setNie(e.value)
                }}
              />
            </> : <>
              <LabelField htmlFor="label">NIE DIAN *</LabelField>
              <Dropdown style={{ width: "22rem" }} value={nie}
                filter showClear filterBy="description"
                optionLabel="description"
                options={listaNieDed} placeholder={"Seleccione un NIE"}
                onChange={(e) => {
                  setNie(e.value)
                }}
              />
            </>

          )
            :
            <>
              <LabelField htmlFor="label">NIE DIAN *</LabelField>
              <Dropdown style={{ width: "22rem" }} value={nie}
                filter showClear filterBy="description"
                optionLabel="description"
                options={listaNieDed} placeholder={"Seleccione un NIE"}
                onChange={(e) => {
                  setNie(e.value)
                }}
              />
            </>
          }
          <LabelField htmlFor="label">Grupo de Certificado de Ingresos y Retenciones</LabelField>
          <Dropdown style={{ width: "22rem" }} value={nie}
            filter showClear filterBy="NAME"
            optionLabel="NAME"
            options={listaCYR} placeholder={cyr ? cyr.NAME : "Seleccione un grupo"}
            onChange={(e) => {
              setCyr(e.value)
            }}
          />
        </Dialog>

        < Dialog header={header} footer={footer} visible={isOpenCargue}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalCargue} >
          <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
          <br />
          <span>2. Diligencie la hoja UploadStatics, teniendo en cuenta los códigos de concepto presentados en la hoja Conceptos del cliente.</span>
          <br />
          <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
        </Dialog >

        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
          <span className="text-900">Novedades Fijas</span>
          <Video header="Instructivo proceso novedades" url={localStorage.getItem('NOVELTIESSTATIC_VIDEO')} />
        </div>

        <ConfBar />

        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate} end={rightToolbarTemplate} />
            <DataTable className="text-xs" value={products} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              scrollHeight="flex" dataKey="STATIC_ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NUMBER_ID', 'NAME', 'CONCEPT', 'ENTIDADSS', 'VALUE', 'BALANCE_VALUE', 'STATUS']}
              header={header1} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
              <Column field="NUMBER_ID" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
              <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column field="CONCEPT" header="Concepto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Cargo" sortable></Column>
              <Column field="ENTIDADSS" header="Entidad AFC ó FVOL" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo de contrato" sortable></Column>
              <Column field="VALUE" header="Valor" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Valor" sortable body={valueBodyTemplate}></Column>
              <Column field="BALANCE_VALUE" header="Saldo inicial" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Saldo inicial" sortable body={balanceValueBodyTemplate}></Column>
              <Column field="BALANCE_END" header="Saldo final" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Saldo final" sortable body={balanceEndBodyTemplate}></Column>
              <Column field="PERIOD" header="Período" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha inicio" sortable></Column>
              <Column field="DATE_INI" body={iniDateTemplate} header="Fecha inicio" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha inicio" sortable></Column>
              <Column field="DATE_END" body={endDateTemplate} header="Fecha fin" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha fin" sortable></Column>
              <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '50px', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>

      </div>

    </div>

  );
}
